import React from 'react';
import cn from 'classnames';

import TextLink from '../TextLink/TextLink';

import classes from './CategoryList.module.scss';
import Props from './CategoryList.props';

const CategoryList = ({ letter, categories, className }: Props) => {
  const renderCategoryList = () => {
    return (
      <ul>
        {categories.map((c) => (
          <li key={c.url}>
            <TextLink href={`/${c.url}`} children={c.label} theme="tertiary" />
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className={cn(classes.CategoryList, className)}>
      <span className={classes.Letter}>{letter}</span>
      {renderCategoryList()}
    </div>
  );
};

export default CategoryList;
